import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationEn from '../locales/en/translation.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    debug: import.meta.env.MODE === 'development',
    interpolation: { escapeValue: false },
    resources: {
      en: {
        translation: translationEn,
      },
    },
  })

export default i18n
